<template>
    <div
        :class="['OrganisationRanking', { 'topRanking': shouldShowTopRanking }]"
        v-skeleton="{
            loading,
            sizes: {
                Small: { width: '12rem', height: '1.75rem'},
            },
            styles: {
                Small: 'margin-bottom: 0.5rem;'
            }

        }"
    >
        <OrganisationTopRanking
            v-if="shouldShowTopRanking"
            :discipline="disciplineName"
            :position="rankingDiscipline! || worldwideRankingPosition!"
            :globalPercentage="worldwideRankingPercentage"
        />

        <span
            v-else-if="worldwideRankingPercentage"
            class="WorldwidePosition"

        >
            <b>Top {{ worldwideRankingPercentage }}%</b> Global Rank
        </span>
    </div>
</template>


<script setup lang="ts">
import { computed } from 'vue';
import { useSearchStore } from '@stores/useSearchStore';
import OrganisationTopRanking from '@components/SearchResults/UniversitySearchResults/OrganisationCard/OrganisationRanking/OrganisationTopRanking/OrganisationTopRanking.vue';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { UNIVERSITY_RANKINGS_SORT } from '@app/routing/mappers/SortMapper';

const searchStore = useSearchStore();

const props = defineProps({
    rankingDiscipline: {
        type: Number,
        required: false,
    },
    disciplineName: {
        type: String,
        required: false,
    },
    worldwideRankingPosition: {
        type: Number,
        required: false,
    },
    worldwideRankingPercentage: {
        type: String,
        required: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const hasDisciplineRanking = computed(() => props.rankingDiscipline && props.disciplineName);
const hasWorldwideRanking = computed(() => props.worldwideRankingPosition && props.worldwideRankingPercentage);

const hasRankingSorting = computed(() => !!searchStore?.filtersSelection?.find(filter =>
    filter.type === FilterType.SORTING &&
    filter.values?.some(value => value.id === UNIVERSITY_RANKINGS_SORT)
));

const shouldShowTopRanking = computed(() => searchStore.filtersSelection.find(filter =>
    filter.type === FilterType.SORTING &&
    filter.values?.some(value => value.id === UNIVERSITY_RANKINGS_SORT)
) && (hasDisciplineRanking.value || hasWorldwideRanking.value || hasRankingSorting.value));
</script>


<style scoped lang="scss">
.OrganisationRanking {
    @include MarginAreas(0.25, 0, 0.5, 0);

    &.topRanking {
        @include Breakpoint(Large, ExtraLarge) {
            @include MarginAreas(0);

            //EXCEPTION!
            margin-bottom: 0.75rem;
        }
    }

    &:not(.topRanking) {
        @include Breakpoint(Large, ExtraLarge) {
            @include MarginAreas(0, 0, 0.5, 0);
        }
    }


    .WorldwidePosition {
        color: $Grey-900;

        @include TextStyle(UiSmallRegular);

        b {
            @include TextStyle(UiSmallSemibold);
        }
    }
}
</style>